/** First http(s) URL in text, if any. */
const URL_RE = /https?:\/\/[^\s<>"'`)\]]+/i;

export function extractFirstUrl(text) {
  if (!text || typeof text !== "string") return null;
  const m = text.match(URL_RE);
  if (!m) return null;
  try {
    const u = new URL(m[0].replace(/[.,;:!?)]+$/, ""));
    if (u.protocol !== "http:" && u.protocol !== "https:") return null;
    return u.href;
  } catch {
    return null;
  }
}

/** Tiny favicon via Google (no CORS for <img>). Fallback only. */
export function faviconForUrl(url) {
  try {
    const host = new URL(url).hostname;
    if (!host) return null;
    return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=64`;
  } catch {
    return null;
  }
}

export function isFaviconUrl(img) {
  return typeof img === "string" && img.includes("google.com/s2/favicons");
}

/** Favicon from first link in title/content, or null. */
export function faviconFromText(...parts) {
  for (const part of parts) {
    const url = extractFirstUrl(part);
    if (url) return faviconForUrl(url);
  }
  return null;
}

/**
 * Prefer article og:image via /api/link-preview; fall back to favicon.
 * Works in browser (relative /api) and Node (absolute origin optional).
 */
export async function resolveLinkThumb(...parts) {
  let url = null;
  for (const part of parts) {
    url = extractFirstUrl(part);
    if (url) break;
  }
  if (!url) return null;

  try {
    const endpoint =
      typeof window !== "undefined"
        ? `/api/link-preview?url=${encodeURIComponent(url)}`
        : null;
    if (endpoint) {
      const res = await fetch(endpoint, { signal: AbortSignal.timeout(9000) });
      if (res.ok) {
        const data = await res.json();
        if (data.image) return data.image;
        if (data.favicon) return data.favicon;
      }
    }
  } catch (err) {
    console.warn("[linkThumb] preview failed:", err?.message || err);
  }
  return faviconForUrl(url);
}

/** True if we should try upgrading img to a real article image. */
export function needsOgUpgrade(img, ...parts) {
  if (!extractFirstUrl(parts.find(Boolean) || "")) return false;
  return !img || isFaviconUrl(img);
}
